// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 562 ? "3975359d" : chunkId) + "." + {"562":"4a072bcd8cf334b0","865":"d235d8305edc27ca"}[chunkId] + ".js";
};